var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.$helpers.inIframe()
        ? _c(
            "b-navbar",
            { staticClass: "navbar", attrs: { toggleable: _vm.isToggleable } },
            [
              _vm.showBackButton
                ? _c(
                    "b-nav-item",
                    {
                      staticClass: "d-block mr-2",
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [
                      _c("base-icon", {
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                          svgClasses: "rotate-180",
                          width: "20",
                          height: "20"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-navbar-brand",
                {
                  class: _vm.navbarBrandClasses,
                  staticStyle: { cursor: "pointer" },
                  on: {
                    "~click": function($event) {
                      return _vm.redirectIfAuthenticated(true)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "navbar-brand-img",
                    style: _vm.getLogoStyles,
                    attrs: { src: _vm.getLogo }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                [
                  _vm.$store.state.session.user
                    ? _c(
                        "b-nav-item",
                        { staticClass: "my-auto d-none d-xl-block" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "profile-link font-weight-bold",
                              attrs: { "data-hj-supress": "" },
                              on: { click: _vm.goProfile }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "profile-pic mr-3 vertical-align-middle",
                                attrs: {
                                  src: _vm.$store.state.session.user.photo
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.$store.state.session.user.name) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn-dropdown d-inline-block px-0",
                          attrs: {
                            variant: "secondary",
                            borderColor: "transparent",
                            backgroundColor: "transparent"
                          }
                        },
                        [
                          _c("hamburguer-dropdown", {
                            staticClass: "dropdown",
                            attrs: {
                              enablePortuguese: "",
                              dontDisplayDropdown: _vm.isToggleable,
                              showLanguageSelector: false
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "menu-items",
                                  fn: function() {
                                    return [
                                      !_vm.inPanel &&
                                      _vm.$store.getters[
                                        "session/userIsPatient"
                                      ]
                                        ? _c(
                                            "div",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _c(
                                                "base-button",
                                                {
                                                  attrs: {
                                                    outline: "",
                                                    blue: "",
                                                    size: "sm"
                                                  },
                                                  on: {
                                                    click: function() {
                                                      return _vm.$router.push(
                                                        "/patient"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "private-layout.home"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("hr")
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.menuServiceItems &&
                                      _vm.menuServiceItems.length > 0
                                        ? _c(
                                            "div",
                                            [
                                              _c("div", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "my-2 d-block font-weight-bold",
                                                    on: {
                                                      click:
                                                        _vm.toggleShowServicesMenu
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "private-layout.services"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("base-icon", {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        src:
                                                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg",
                                                        color: _vm.BLUE_COLOUR,
                                                        svgClasses:
                                                          _vm.caretSubMenuClass,
                                                        height: 12,
                                                        width: 12
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("CollapseTransition", [
                                                _vm.showServicesMenu
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "submenu"
                                                      },
                                                      [
                                                        _c("hr"),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.menuServiceItems,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "list-items-" +
                                                                  index
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "my-2 d-block font-weight-bold",
                                                                    on: {
                                                                      click:
                                                                        item.action
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          item.title
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("hr")
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]),
                                              _vm._v(" "),
                                              !_vm.showServicesMenu
                                                ? _c("hr")
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$store.state.session.user
                                        ? _c(
                                            "div",
                                            [
                                              _vm._l(
                                                _vm.notTabMenuItems,
                                                function(i) {
                                                  return _c(
                                                    "div",
                                                    { key: i.title },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "my-2 d-block font-weight-bold",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onTabClick(
                                                                i
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(i.title) +
                                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                                          ),
                                                          i.bubble
                                                            ? _c(
                                                                "b-badge",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    variant:
                                                                      "info"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      i.bubble
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("hr")
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _vm._l(_vm.mainMenuItems, function(
                                            i
                                          ) {
                                            return _c("div", { key: i.title }, [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "my-2 d-block font-weight-bold",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onTabClick(i)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(i.title) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  i.bubble
                                                    ? _c(
                                                        "b-badge",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            variant: "info"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(i.bubble)
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("hr")
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("lang-selector", {
                                        staticClass: "lang-cnt text-center",
                                        attrs: { enablePortuguese: "" }
                                      }),
                                      _vm._v(" "),
                                      _c("hr"),
                                      _vm._v(" "),
                                      _vm.$store.getters[
                                        "session/userIsPatient"
                                      ]
                                        ? _c("div", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "font-weight-bold",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$store.commit(
                                                      "layout/toggleChangeUserModalVisible"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("menu.change-user")
                                                  )
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.$store.state.session.user
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "my-2",
                                              on: { click: _vm.logOff }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "my-2 font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("logOff"))
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1480024937
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54a10552", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a10552","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PrivateLayoutMenu.vue
// module id = 2062
// module chunks = 117